import { BoxProps, Stack, styled } from '@mui/material';
import { forwardRef } from 'react';

type MapControlFooterProps = BoxProps & {
  actions?: React.ReactNode;
};

export const MapControlFooter = styled(
  forwardRef<HTMLDivElement, MapControlFooterProps>(
    ({ actions, ...props }, ref) => (
      <Stack
        ref={ref}
        direction='row'
        justifyContent='flex-end'
        alignItems='center'
        spacing={1}
        {...props}
        sx={{
          padding: 5,
          ...props.sx,
        }}
      >
        {actions}
      </Stack>
    )
  )
)({});
